<template>
  <button
    type="button"
    :class="`${classes} font-inter flex transform select-none items-center justify-center gap-2 rounded border border-gray-200 bg-transparent px-4 py-3 text-min text-primary shadow-sm hover:-translate-y-0.5 hover:text-main-secondary active:text-main-primary`"
    @click="$emit('click')"
  >
    <span><slot /></span>
  </button>
</template>

<script>
export default {
  name: 'GhostButton',

  props: {
    classes: {
      type: String,
      default: '',
    },
  },

  emits: ['click'],
}
</script>
